import { render, staticRenderFns } from "./gradually.vue?vue&type=template&id=50eca4fe&scoped=true&"
import script from "./gradually.vue?vue&type=script&lang=js&"
export * from "./gradually.vue?vue&type=script&lang=js&"
import style0 from "./gradually.vue?vue&type=style&index=0&id=50eca4fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eca4fe",
  null
  
)

export default component.exports